function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#175664}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3137",
  "data-name": "Path 3137",
  className: "cls-1",
  d: "m643.7 394.585 5.054-3.126.987-.612h16.4a10.212 10.212 0 0 0 10.2-10.2v-8.159a10.214 10.214 0 0 0-10.2-10.2H653.9a10.214 10.214 0 0 0-10.2 10.2v22.1m-4.081 7.322v-29.42A14.282 14.282 0 0 1 653.9 358.2h12.243a14.282 14.282 0 0 1 14.279 14.284v8.159a14.28 14.28 0 0 1-14.279 14.281H650.9z",
  transform: "translate(-639.617 -358.204)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3147",
  "data-name": "Path 3147",
  className: "cls-1",
  d: "M660.028 368.285h-11.372a2.04 2.04 0 1 1 0-4.08h11.371a2.04 2.04 0 0 1 0 4.08z",
  transform: "translate(-633.94 -347.962)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3148",
  "data-name": "Path 3148",
  className: "cls-1",
  d: "M13.412 4.08H2.04a2.04 2.04 0 1 1 0-4.08h11.372a2.04 2.04 0 0 1 0 4.08z",
  transform: "rotate(90 5.942 16.5)"
});

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.804,
    height: 43.703,
    viewBox: "0 0 40.804 43.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.3635ba85.svg";
export { ForwardRef as ReactComponent };